import { triggerAuthClear } from '../../auth/clearAuthState'
import type { Props } from '../../definition'

export default async function validateToken(p: Props): Promise<boolean> {
	const db = R.surreal?.db
	const authState = R.db?.states.auth.get()
	const token = authState?.token

	if (!db || !token) {
		log.error('SurrealDB connection or token is not available')
		return false
	}

	try {
		// TODO надо убрать пароль из хранилища и сделать на refresh token, когда тот появится в SurrealDB
		const isValid = await db.authenticate(token)

		return isValid
	} catch (e: any) {
		log.error('SurrealDB token validation failed', e.message)

		// Сбросим состояние при ошибке токена через централизованную функцию
		await triggerAuthClear()

		return false
	}
}
